import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import extraBg from '../../assets/images/bet-on-poker/extra-bg.png';

export function ExtraButton({ handleShowExtraBets }) {
  const t = useTranslation();
  return (
    <div className='bet-on-poker-extra'>
      <div className='bet-on-poker-extra-chip orange shining-seat' onClick={handleShowExtraBets}>
        <img src={extraBg} alt='' />
      </div>
      <p className='bet-on-poker-extra-title'>{t('EXTRA')}</p>
    </div>
  );
}
